import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { HotelsListWrapper } from './hotel-list/HotelsList';
import { useIntl } from 'react-intl';

const HotelPage = () => {
  const intl = useIntl(); 

  const hotelsBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'HOTEL_PAGE.BREADCRUMB' }), 
      path: '/apps/hotel-management/hotels',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='hotels'
          element={
            <>
              <PageTitle breadcrumbs={hotelsBreadcrumbs}>
                {intl.formatMessage({ id: 'HOTEL_PAGE.TITLE' })}
              </PageTitle>
              <HotelsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/hotel-management/hotels' />} />
    </Routes>
  );
};

export default HotelPage;